import { useContext, useState } from 'react';
import { InterfaceContext } from './store/InterfaceProvider';
const ErrorWindow = () => {
    const { error, recentError, setAppError, errorLocation } = useContext(InterfaceContext);
    const [showError, setShowError] = useState(false);
    const useError = recentError?.cause || recentError || {};
    const parsedError = JSON.stringify(useError, Object.getOwnPropertyNames(useError), 2);

    if (!error) return null;
    return (
        <div id="error-window">
            <div className="inner-window">
                <div className="win-title">
                    <h3>Error</h3>
                    <div className="icon close" onClick={() => setAppError(false)}></div>
                </div>
                <div className="win-content" onDoubleClick={() => setShowError(true)}>
                    An Error Occurred Loading the page.
                    {showError && (
                        <>
                            <p>
                                Occurred in: <i>{errorLocation}</i>
                            </p>{' '}
                            <pre>{parsedError}</pre>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};
export default ErrorWindow;
